// extracted by mini-css-extract-plugin
export default {"mCard":"pE-z","image":"qE-z","imageNoBackground":"rE-z","imageHasCategory":"sE-z","fullWidth":"tE-z"};